import React from 'react'
import { ReactComponent as EditCircleSvg } from 'icons/Edit Circle.svg'
import { ReactComponent as MessageSvg } from 'icons/Message.svg'
import { ReactComponent as FailSvg } from 'icons/Fail.svg'
import { ReactComponent as SuccessSvg } from 'icons/Success.svg'
import { ReactComponent as WarningSvg } from 'icons/Warning.svg'
import { ReactComponent as TermsAndConditionSvg } from 'icons/TermsAndCondition.svg'
import { ReactComponent as GreenAddSvg } from 'icons/GreenAdd.svg'
import { ReactComponent as RedMinusSvg } from 'icons/RedMinus.svg'
import { ReactComponent as MoveToListSvg } from 'icons/MoveToList.svg'
import { ReactComponent as DragSvg } from 'icons/Drag.svg'
import { ReactComponent as WaitlistSvg } from 'icons/Waitlist.svg'
import { ReactComponent as PriorityListSvg } from 'icons/PriorityList.svg'
import { ReactComponent as ApprovalOrderSvg } from 'icons/ApprovalOrder.svg'
import { ReactComponent as RightArrowSvg } from 'icons/RightArrow.svg'
import { ReactComponent as LogoSvg } from 'icons/Logo.svg'
import { ReactComponent as CampaignsSvg } from 'icons/Sidebar/Campaigns.svg'
import { ReactComponent as CampaigsActiveSvg } from 'icons/Sidebar/CampaignsActive.svg'
import { ReactComponent as TriangleSvg } from 'icons/Sidebar/Triangle.svg'
import { ReactComponent as ManageTeamsSvg } from 'icons/Sidebar/ManageTeams.svg'
import { ReactComponent as ManageTeamsActiveSvg } from 'icons/Sidebar/ManageTeamsActive.svg'
import { ReactComponent as PartipostsSvg } from 'icons/Sidebar/Partiposts.svg'
import { ReactComponent as PartipostsActiveSvg } from 'icons/Sidebar/PartipostsActive.svg'
import { ReactComponent as BannersSvg } from 'icons/Sidebar/Banners.svg'
import { ReactComponent as BannersActiveSvg } from 'icons/Sidebar/BannersActive.svg'
import { ReactComponent as ProfileSvg } from 'icons/Sidebar/Profile.svg'
import { ReactComponent as CountrySvg } from 'icons/Sidebar/Country.svg'
import { ReactComponent as BurgerMenuSvg } from 'icons/Sidebar/BurgerMenu.svg'
import { ReactComponent as TeamSvg } from 'icons/Sidebar/Team.svg'
import { ReactComponent as FullLogoSvg } from 'icons/FullLogo.svg'
import { ReactComponent as CloseSvg } from 'icons/Close.svg'
import { ReactComponent as DownArrowSvg } from 'icons/DownArrow.svg'
import { ReactComponent as LanguageSvg } from 'icons/Language.svg'
import { ReactComponent as SelectorDownSvg } from 'icons/SelectorArrow.svg'
import { ReactComponent as QuestionMarkSvg } from 'icons/QuestionMark.svg'
import { ReactComponent as ToggleOffSvg } from 'icons/ToggleOff.svg'
import { ReactComponent as ToggleOnSvg } from 'icons/ToggleOn.svg'
import { ReactComponent as ShowToolTipSvg } from 'icons/ShowToolTip.svg'
import { ReactComponent as EmptyStateSvg } from 'icons/EmptyState.svg'
import { ReactComponent as NotFoundIconSvg } from 'icons/NotFoundIcon.svg'
import { ReactComponent as PlusNoBgSvg } from 'icons/PlusNoBg.svg'
import { ReactComponent as PurchaseCartSvg } from 'icons/PurchaseCart.svg'
import { ReactComponent as AttendEventSvg } from 'icons/AttendEvent.svg'
import { ReactComponent as InstagramIconSvg } from 'icons/InstagramIcon.svg'
import { ReactComponent as FacebookIconSvg } from 'icons/FacebookIcon.svg'
import { ReactComponent as TiktokIconSvg } from 'icons/TiktokIcon.svg'
import { ReactComponent as RegistrationPhaseSvg } from 'icons/RegistrationPhase.svg'
import { ReactComponent as MakePurchaseSvg } from 'icons/MakePurchase.svg'
import { ReactComponent as AgeSvg } from 'icons/Requirement/Age.svg'
import { ReactComponent as CampaignConflictSvg } from 'icons/Requirement/CampaignConflict.svg'
import { ReactComponent as FacebookSvg } from 'icons/Requirement/Facebook.svg'
import { ReactComponent as FreeInputSvg } from 'icons/Requirement/FreeInput.svg'
import { ReactComponent as GenderSvg } from 'icons/Requirement/Gender.svg'
import { ReactComponent as InstagramSvg } from 'icons/Requirement/Instagram.svg'
import { ReactComponent as LocationSvg } from 'icons/Requirement/Location.svg'
import { ReactComponent as OccupationSvg } from 'icons/Requirement/Occupation.svg'
import { ReactComponent as TiktokSvg } from 'icons/Requirement/Tiktok.svg'
import { ReactComponent as TwitterSvg } from 'icons/Requirement/Twitter.svg'
import { ReactComponent as ProfileTypeSvg } from 'icons/Requirement/ProfileType.svg'
import { ReactComponent as DatePickerSvg } from 'icons/DatePicker.svg'
import { ReactComponent as EmptyState2Icon } from 'icons/EmptyState2.svg'
import { ReactComponent as TextBlockIcon } from 'icons/TextBlock.svg'
import { ReactComponent as Drag2Icon } from 'icons/Drag2.svg'
import { ReactComponent as PhotoIcon } from 'icons/Photo.svg'
import { ReactComponent as LinkIcon } from 'icons/Link.svg'
import { ReactComponent as TextIcon } from 'icons/Text.svg'
import { ReactComponent as MultipleChoiceIcon } from 'icons/MultipleChoice.svg'
import { ReactComponent as NumberIcon } from 'icons/Number.svg'
import { ReactComponent as CustomTaskIcon } from 'icons/CustomTask.svg'
import { ReactComponent as MoreHorizontalIcon } from 'icons/MoreHorizontal.svg'
import { ReactComponent as AllSubmissionsSvg } from 'icons/AllSubmissions.svg'
import { ReactComponent as RegistrationSvg } from 'icons/Registration.svg'
import { ReactComponent as EmptyTagSvg } from 'icons/EmptyTag.svg'
import { ReactComponent as CheckCircleSvg } from 'icons/CheckCircle.svg'
import { ReactComponent as ExpireLinkSvg } from 'icons/ExpireLink.svg'
import { ReactComponent as EmptyFilterState } from 'icons/EmptyFilterResult.svg'
import { ReactComponent as XiaohongshuIconSvg } from 'icons/XiaohongshuIcon.svg'
import { ReactComponent as XiaohongshuIconFilledSvg } from 'icons/XiaohongshuIconFilled.svg'

const EditCircle: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <EditCircleSvg {...props} />
const Message: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <MessageSvg {...props} />
const Fail: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <FailSvg {...props} />
const Success: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <SuccessSvg {...props} />
const Warning: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <WarningSvg {...props} />
const TermsAndCondition: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <TermsAndConditionSvg {...props} />
const GreenAdd: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <GreenAddSvg {...props} />
const RedMinus: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <RedMinusSvg {...props} />
const MoveToList: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <MoveToListSvg {...props} />
const Drag: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <DragSvg {...props} />
const Waitlist: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <WaitlistSvg {...props} />
const PriorityList: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <PriorityListSvg {...props} />
const ApprovalOrder: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ApprovalOrderSvg {...props} />
const RightArrow: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <RightArrowSvg {...props} />
const Logo: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <LogoSvg {...props} />
const CampaignsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <CampaignsSvg {...props} />
const CampaignsActiveIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <CampaigsActiveSvg {...props} />
const TriangleIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <TriangleSvg {...props} />
const ManageTeamsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ManageTeamsSvg {...props} />
const ManageTeamsActiveIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
    <ManageTeamsActiveSvg {...props} />
)
const PartipostsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <PartipostsSvg {...props} />
const PartipostsActiveIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
    <PartipostsActiveSvg {...props} />
)
const BannersIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <BannersSvg {...props} />
const BannersActiveIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <BannersActiveSvg {...props} />
const ProfileIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ProfileSvg {...props} />
const CountryIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <CountrySvg {...props} />
const FullLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <FullLogoSvg {...props} />
const BurgerMenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <BurgerMenuSvg {...props} />
const CloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <CloseSvg {...props} />
const DownArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <DownArrowSvg {...props} />
const LanguageIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <LanguageSvg {...props} />
const SelectorDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <SelectorDownSvg {...props} />
const QuestionMarkIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <QuestionMarkSvg {...props} />
const ToggleOffIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ToggleOffSvg {...props} />
const ToggleOnIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ToggleOnSvg {...props} />
const TeamIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <TeamSvg {...props} />
const EmptyStateIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <EmptyStateSvg {...props} />
const NotFoundIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <NotFoundIconSvg {...props} />
const PlusNoBgIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <PlusNoBgSvg {...props} />
const PurchaseCartIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <PurchaseCartSvg {...props} />
const AttendEventIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <AttendEventSvg {...props} />
const InstagramIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <InstagramIconSvg {...props} />
const FacebookIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <FacebookIconSvg {...props} />
const TiktokIcon2: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <TiktokIconSvg {...props} />
const RegistrationPhaseIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
    <RegistrationPhaseSvg {...props} />
)
const MakePurchaseIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <MakePurchaseSvg {...props} />
const AgeIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <AgeSvg {...props} />
const CampaignConflictIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
    <CampaignConflictSvg {...props} />
)
const FacebookRequirementIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <FacebookSvg {...props} />
const FreeInputIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <FreeInputSvg {...props} />
const GenderIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <GenderSvg {...props} />
const InstagramRequirementIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <InstagramSvg {...props} />
const LocationIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <LocationSvg {...props} />
const OccupationIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <OccupationSvg {...props} />
const TiktokIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <TiktokSvg {...props} />
const TwitterIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <TwitterSvg {...props} />
const DatePickerIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <DatePickerSvg {...props} />
const ShowToolTipIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ShowToolTipSvg {...props} />
const AllSubmissionsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <AllSubmissionsSvg {...props} />
const RegistrationIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <RegistrationSvg {...props} />
const ProfileTypeIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ProfileTypeSvg {...props} />
const EmptyTagIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <EmptyTagSvg {...props} />
const CheckCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <CheckCircleSvg {...props} />
const ExpireLinkIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <ExpireLinkSvg {...props} />
const EmptyFilterStateIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <EmptyFilterState {...props} />
const XiaohongshuIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => <XiaohongshuIconSvg {...props} />
const XiaohongshuIconFilled: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
    <XiaohongshuIconFilledSvg {...props} />
)

export default {
    EditCircle,
    Message,
    Fail,
    Success,
    Warning,
    TermsAndCondition,
    GreenAdd,
    RedMinus,
    MoveToList,
    Drag,
    Drag2Icon,
    Waitlist,
    PriorityList,
    ApprovalOrder,
    RightArrow,
    Logo,
    CampaignsIcon,
    TriangleIcon,
    ManageTeamsIcon,
    PartipostsIcon,
    BannersIcon,
    BannersActiveIcon,
    ProfileIcon,
    CountryIcon,
    FullLogoIcon,
    BurgerMenuIcon,
    CloseIcon,
    DownArrowIcon,
    LanguageIcon,
    ManageTeamsActiveIcon,
    CampaignsActiveIcon,
    PartipostsActiveIcon,
    SelectorDownIcon,
    QuestionMarkIcon,
    ToggleOffIcon,
    ToggleOnIcon,
    ShowToolTipIcon,
    TeamIcon,
    EmptyStateIcon,
    PlusNoBgIcon,
    PurchaseCartIcon,
    AttendEventIcon,
    InstagramIcon,
    FacebookIcon,
    RegistrationPhaseIcon,
    MakePurchaseIcon,
    AgeIcon,
    CampaignConflictIcon,
    FacebookRequirementIcon,
    FreeInputIcon,
    GenderIcon,
    InstagramRequirementIcon,
    LocationIcon,
    OccupationIcon,
    TiktokIcon,
    TiktokIcon2,
    TwitterIcon,
    DatePickerIcon,
    EmptyState2Icon,
    EmptyFilterStateIcon,
    TextBlockIcon,
    PhotoIcon,
    LinkIcon,
    TextIcon,
    CustomTaskIcon,
    MoreHorizontalIcon,
    MultipleChoiceIcon,
    NumberIcon,
    NotFoundIcon,
    AllSubmissionsIcon,
    RegistrationIcon,
    ProfileTypeIcon,
    EmptyTagIcon,
    CheckCircleIcon,
    ExpireLinkIcon,
    XiaohongshuIcon,
    XiaohongshuIconFilled,
}
